<template></template>

<script>
import qs from "querystring";
import { wxLogin } from "../api/api";
const parseParam = _ => {
  const search = window.location.href.split("?")[1];
  if (!search) return {};
  return qs.parse(search);
};
let appid = "wx6d40876f621b822b";

export default {
  async created() {
    let code = parseParam().code;
    let force = parseParam().force;
    if (code) {
      try {
        const res = await wxLogin(code);
        if (!res.code) {
          const next =
            parseParam().next ||
            encodeURIComponent(`${location.protocol}//${location.host}/book`);
          location.href = decodeURIComponent(next);
        } else {
          alert("微信登录失败");
        }
      } catch (e) {}
    } else {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
        window.location.href
      )}&response_type=code&scope=snsapi_base#wechat_redirect`;
    }
  }
};
</script>


// WEBPACK FOOTER //
// wechat-login.vue?628b5e16